import jStat from 'jstat';

export interface PercentileResult {
  percentiles: {
    p25: number;  // First quartile
    p50: number;  // Median
    p75: number;  // Third quartile
    p90: number;  // 90th percentile
    p95: number;  // 95th percentile
    p99: number;  // 99th percentile
  };
  data: number[];
  interpretation: string;
}

export function calculatePercentiles(data: number[]): PercentileResult {
  const sortedData = [...data].sort((a, b) => a - b);
  
  return {
    percentiles: {
      p25: jStat.percentile(sortedData, 0.25),
      p50: jStat.percentile(sortedData, 0.50),
      p75: jStat.percentile(sortedData, 0.75),
      p90: jStat.percentile(sortedData, 0.90),
      p95: jStat.percentile(sortedData, 0.95),
      p99: jStat.percentile(sortedData, 0.99)
    },
    data: sortedData,
    interpretation: 'Percentiles show how the data is distributed. For example, 25% of values fall below P25.'
  };
} 